import Vue from 'vue';
import VueResource from 'vue-resource';
import converterMoeda from '~js/converter-moeda';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

function normalizarParaSalvar(solicitacao) {
  delete solicitacao.projeto;

  solicitacao.itensSolicitacaoCompra.map(item => {
    // item.quantidade = converterMoeda.paraDolar(item.quantidade);
    // item.valorEstimado = converterMoeda.paraDolar(item.valorEstimado);

    delete item.projetoMetaEtapa;
    delete item.rubrica;
    delete item.subrubrica;
  });

  return solicitacao;
}

function normalizarParaVisualizar(solicitacao) {
  solicitacao.itensSolicitacaoCompra.map(item => {
    item.quantidade = converterMoeda.paraReal(item.quantidade);
    item.valorEstimado = converterMoeda.paraReal(item.valorEstimado);
  });

  return solicitacao;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    const periodo = parametros.periodo;
    delete parametros.periodo;

    if (periodo) {
      parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
      parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }

    return Vue.http.get('/api/solicitacaocompras', { params: parametros });
  },
  adicionar: (solicitacao, arquivos) => {
    solicitacao = normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;

    solicitacao = converterObjetoFormData(solicitacao);

    return Vue.http.post('/api/solicitacaocompras', solicitacao).then(res => res.data.id);
  },
  alterar: (solicitacao, arquivos, id) => {
    solicitacao = normalizarParaSalvar(solicitacao, id);
    solicitacao.arquivos = arquivos;
    
    solicitacao = converterObjetoFormData(solicitacao);
    
    return Vue.http.put(`/api/solicitacaocompras/${id}`, solicitacao).then(res => res.data.id);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/solicitacaocompras/${id}`)
      .then(response => response.data)
      .then(solicitacao => normalizarParaVisualizar(solicitacao));
  },
  liberar: id => {
    return Vue.http.post(`/api/solicitacaocompras/${id}/liberar`)
      .then(response => response.data);
  },
  cancelar: id => {
    return Vue.http.post(`/api/solicitacaocompras/${id}/cancelar`)
      .then(response => response.data);
  },
  statusItens: (id, idPedidoCompra) => {
    return Vue.http.get(`/api/solicitacaocompras/${id}/statusitens/${idPedidoCompra}`)
      .then(response => response.data);
  },
  reenviarEmail: id => {
    return Vue.http.get(`/api/solicitacaocompras/${id}/reenviaremail`)
      .then(response => response.data);
  },
  arquivos: id => {
    return Vue.http.get(`/api/solicitacaocompras/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/solicitacaocompras/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
  produtosCompra: function (IDTipoProduto, TipoCompra) {   
    return Vue.http.get(`/api/solicitacaocompras/${IDTipoProduto}/ProdutosCompra/${TipoCompra}`)
      .then(response => response.data);
  },
  tiposProdutosCompra: function (TipoCompra) {
    return Vue.http.get(`/api/solicitacaocompras/${TipoCompra}/TiposProdutosCompra`)
      .then(response => response.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-compra/servico.js